// extracted by mini-css-extract-plugin
export var focusedOtherDismissButton = "vCgFO";
export var focusedOtherDismissButtonIcon = "ZQqbi";
export var focusedOtherPrimaryText = "p7a8u";
export var focusedOtherPrimaryTextMCL = "T48XQ";
export var focusedOtherRollupContainer = "t6lxx";
export var focusedOtherRollupContainerDenseless = "Bm46e";
export var focusedOtherRollupPinned = "_cZ3o";
export var focusedOtherRollupPinnedUnderColumnHeaders = "SBpaX";
export var focusedOtherSecondaryText = "vDQso";
export var prioritizeRollupContainer = "aUcPb";
export var prioritizeRollupContainerDenseless = "kdz17";
export var rollupTextSize12 = "YrHN5";
export var rollupTextSize14 = "RH_1A";